import React, { useContext } from "react";
import Cover from "../core/cover";
import { Context } from "../../context";
const Woocommercefeaturedproduct = (props) => {
    const context = useContext(Context);
    const product = context.wc.allProducts.find((product) => {
        return (props.attributes.productId === parseInt(product.databaseId) ||
            (product.variations?.nodes || [])
                .map((e) => parseInt(e.databaseId))
                .includes(props.attributes.productId));
    });
    if (!product) {
        return React.createElement(React.Fragment, null);
    }
    const title = {
        name: "core/heading",
        outerHTML: "<h2>" + product.name + "</h2>",
    };
    const description = props.attributes.showDesc === false || !product.description?.length
        ? undefined
        : {
            name: "core/paragraph",
            outerHTML: "<p>" + product.description + "</p>",
        };
    const price = props.attributes.showPrice === false
        ? undefined
        : {
            name: "woocommerce/price",
            attributes: {
                price: {
                    onSale: product.onSale,
                    regularPrice: product.regularPrice || product.price,
                    salePrice: product.salePrice,
                },
            },
        };
    const innerBlocks = [title, description, price, ...props.innerBlocks].filter((e) => e !== undefined);
    return (React.createElement(Cover, { ...props, attributes: {
            ...(props.attributes || {}),
            dimRatio: 0,
            className: (props.attributes.className || "") + " wp-block-cover",
        }, innerBlocks: innerBlocks, targetImage: props.attributes.mediaId
            ? undefined
            : product.galleryImages.nodes[0] || product.mediaContent.nodes[0] }));
};
export default Woocommercefeaturedproduct;
